import React from 'react'
import { AgeTargetingBanner } from 'components/index/AgeTargetingBanner'
import YesNoGateBanner from 'components/index/YesNoBanner'

export const GateBanner = ({ brk, onUnlock, onNoClick, onYesClick }) => {
  if (brk.ageGate && brk.hasAgeGating) {
    return <AgeTargetingBanner brk={brk} setStepLocked={onUnlock} />
  }

  if (brk.hasYesNoGate) {
    return (
      <YesNoGateBanner
        recentBreaks={brk.recentBreaks}
        onNoClick={onNoClick}
        onYesClick={onYesClick}
        yesNoGate={brk.yesNoGate || {}}
      />
    )
  }

  return null
}
